import React, {useState, useEffect, useRef} from 'react';
import {useObserver} from "Hooks/useObserver";
import {HeroText} from '../HeroText';
import useBreakpoint from "Hooks/useBreakpoint";
import {Video, VideoButton, VideoWrapper} from './Video.styles';

export const HeroVideo = ({VideoLink, height, Link, ...rest}) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();
  const observe = useObserver(domRef);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const isMobile = useBreakpoint("mobile");
  useEffect(() => {
    if (!isVisible && observe) {
      setVisible(true);
    }
  }, [observe]);

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (!isMobile ?
      <VideoWrapper ref={domRef} {...{height}} className={'v--hero--video'}>
        {isVisible ? <VideoButton onClick={togglePlayPause} aria-label={isPlaying ? "pause video" : "play video"}>
          <i className={isPlaying ? "icon-pause-video" : "icon-play-video"} aria-hidden="true"></i>
        </VideoButton> : null}
        {isVisible ?
          <Video ref={videoRef} autoPlay loop muted playsInline width="100%" data-object-fit="cover"
                 aria-hidden="true">
            <source src={VideoLink} type="video/mp4"/>
          </Video> : null}
        <HeroText
          ButtonText={Link?.Name}
          ButtonLink={Link?.Url}
          ShowButton={Link?.Url.length > 0}
          isVideo={true}
          {...rest}
        />
      </VideoWrapper> : <VideoWrapper ref={domRef} {...{height}} className={'v--hero--video'}>
        {isVisible ?
          <VideoWrapper>
            <VideoButton onClick={togglePlayPause} aria-label={isPlaying ? "pause video" : "play video"}>
              <i className={isPlaying ? "icon-pause-video" : "icon-play-video"} aria-hidden="true"></i>
            </VideoButton>
            <Video ref={videoRef} autoPlay loop muted playsInline width="100%" data-object-fit="cover"
                   aria-hidden="true">
              <source src={VideoLink} type="video/mp4"/>
            </Video> </VideoWrapper> : null}
        <HeroText
          ButtonText={Link?.Name}
          ButtonLink={Link?.Url}
          ShowButton={Link?.Url.length > 0}
          isVideo={true}
          {...rest}
        />
      </VideoWrapper>

  )
};
